const v = "4.8.0";
const meta = {
  g: "LottieFiles AE 3.3.6",
  a: "",
  k: "",
  d: "",
  tc: ""
};
const fr = 29.9700012207031;
const ip = 0;
const op = 101.000004113814;
const w = 80;
const h = 88;
const nm = "230602_quiz_count";
const ddd = 0;
const assets = [];
const layers = [
  {
    ddd: 0,
    ind: 1,
    ty: 3,
    nm: "Null 1",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 0,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 1,
        k: [
          {
            i: {
              x: 0.284,
              y: 1
            },
            o: {
              x: 0.333,
              y: 0
            },
            t: 0,
            s: [
              40,
              44,
              0
            ],
            to: [
              0,
              -29.333,
              0
            ],
            ti: [
              0,
              29.333,
              0
            ]
          },
          {
            i: {
              x: 0,
              y: 0
            },
            o: {
              x: 0.971,
              y: 0.971
            },
            t: 40,
            s: [
              40,
              -132,
              0
            ],
            to: [
              0,
              0,
              0
            ],
            ti: [
              0,
              0,
              0
            ]
          },
          {
            i: {
              x: 0.486,
              y: 1
            },
            o: {
              x: 0.599,
              y: 0
            },
            t: 50,
            s: [
              40,
              -132,
              0
            ],
            to: [
              0,
              29.333,
              0
            ],
            ti: [
              0,
              -29.333,
              0
            ]
          },
          {
            t: 90.0000036657751,
            s: [
              40,
              44,
              0
            ]
          }
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          50,
          50,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    ip: 0,
    op: 101.000004113814,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 2,
    ty: 4,
    nm: "3 윤곽선",
    parent: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          48.406,
          225.75,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          -2.147,
          -14.969,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    -7.242,
                    0
                  ],
                  [
                    0.047,
                    5.742
                  ],
                  [
                    4.781,
                    0.633
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.047,
                    3.797
                  ],
                  [
                    6.891,
                    0
                  ],
                  [
                    0.141,
                    -5.695
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -3.188,
                    0
                  ],
                  [
                    0.023,
                    -2.859
                  ],
                  [
                    3.609,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    -3.047
                  ],
                  [
                    3.727,
                    0.023
                  ],
                  [
                    0.164,
                    2.719
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    7.336,
                    0
                  ],
                  [
                    0.047,
                    -4.266
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    3.703,
                    -0.773
                  ],
                  [
                    0.047,
                    -5.203
                  ],
                  [
                    -6.633,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.117,
                    -2.859
                  ],
                  [
                    3.305,
                    0
                  ],
                  [
                    0.023,
                    2.953
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    4.406,
                    0.023
                  ],
                  [
                    0,
                    3.023
                  ],
                  [
                    -3.539,
                    0.023
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0.141,
                    5.719
                  ]
                ],
                v: [
                  [
                    -0.623,
                    2.469
                  ],
                  [
                    12.033,
                    -7.422
                  ],
                  [
                    4.58,
                    -15.391
                  ],
                  [
                    4.58,
                    -15.672
                  ],
                  [
                    10.767,
                    -22.984
                  ],
                  [
                    -0.53,
                    -32.406
                  ],
                  [
                    -12.483,
                    -22.797
                  ],
                  [
                    -6.623,
                    -22.797
                  ],
                  [
                    -0.576,
                    -27.438
                  ],
                  [
                    4.861,
                    -22.656
                  ],
                  [
                    -1.233,
                    -17.688
                  ],
                  [
                    -4.28,
                    -17.688
                  ],
                  [
                    -4.28,
                    -13
                  ],
                  [
                    -1.233,
                    -13
                  ],
                  [
                    5.799,
                    -7.75
                  ],
                  [
                    -0.623,
                    -2.688
                  ],
                  [
                    -7.045,
                    -7.188
                  ],
                  [
                    -13.186,
                    -7.188
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "3",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.333330012303,
                0.764710011202,
                1,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "3",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 0,
    op: 101.000004113814,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 4,
    ty: 4,
    nm: "2 윤곽선",
    parent: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          50,
          137.766,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          -0.541,
          -15.203,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.023,
                    3.82
                  ],
                  [
                    6.938,
                    0
                  ],
                  [
                    -0.023,
                    -6.422
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -3.492,
                    0
                  ],
                  [
                    0,
                    -3.164
                  ],
                  [
                    3.422,
                    -3.422
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    6.68,
                    -6.305
                  ],
                  [
                    -0.023,
                    -5.695
                  ],
                  [
                    -6.773,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    -0.023,
                    -3.445
                  ],
                  [
                    3.305,
                    0
                  ],
                  [
                    0,
                    2.859
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    -12.248,
                    2
                  ],
                  [
                    11.33,
                    2
                  ],
                  [
                    11.33,
                    -3.109
                  ],
                  [
                    -3.764,
                    -3.109
                  ],
                  [
                    -3.764,
                    -3.344
                  ],
                  [
                    2.283,
                    -9.344
                  ],
                  [
                    10.814,
                    -22.563
                  ],
                  [
                    -0.811,
                    -32.406
                  ],
                  [
                    -12.389,
                    -21.813
                  ],
                  [
                    -6.576,
                    -21.813
                  ],
                  [
                    -0.858,
                    -27.438
                  ],
                  [
                    4.955,
                    -22.281
                  ],
                  [
                    -0.248,
                    -13.984
                  ],
                  [
                    -12.248,
                    -2.406
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "2",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.333330012303,
                0.764710011202,
                1,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "2",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 0,
    op: 101.000004113814,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 6,
    ty: 4,
    nm: "1 윤곽선",
    parent: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          50,
          50,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          -2.147,
          -14.969,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ind: 0,
            ty: "sh",
            ix: 1,
            ks: {
              a: 0,
              k: {
                i: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                o: [
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ],
                  [
                    0,
                    0
                  ]
                ],
                v: [
                  [
                    4.978,
                    -31.938
                  ],
                  [
                    -0.881,
                    -31.938
                  ],
                  [
                    -9.272,
                    -26.5
                  ],
                  [
                    -9.272,
                    -20.922
                  ],
                  [
                    -1.35,
                    -25.984
                  ],
                  [
                    -1.162,
                    -25.984
                  ],
                  [
                    -1.162,
                    2
                  ],
                  [
                    4.978,
                    2
                  ]
                ],
                c: true
              },
              ix: 2
            },
            nm: "1",
            mn: "ADBE Vector Shape - Group",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.333330012303,
                0.764710011202,
                1,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "칠 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "변형"
          }
        ],
        nm: "1",
        np: 3,
        cix: 2,
        bm: 0,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 0,
    op: 101.000004113814,
    st: 0,
    bm: 0
  }
];
const markers = [];
const countingAnimation = {
  v,
  meta,
  fr,
  ip,
  op,
  w,
  h,
  nm,
  ddd,
  assets,
  layers,
  markers
};
export {
  assets,
  ddd,
  countingAnimation as default,
  fr,
  h,
  ip,
  layers,
  markers,
  meta,
  nm,
  op,
  v,
  w
};
//# sourceMappingURL=quiz_counting.json.js.map
